// this is implicitly testing for browser compatibility using the srcdoc attribute
// see list of supporting browsers here https://www.w3schools.com/tags/att_iframe_srcdoc.asp
export const isSupportedBrowser = () =>
  !!("srcdoc" in document.createElement("iframe"));
